document.addEventListener("DOMContentLoaded", function () {
    let collectionLinks = document.querySelectorAll(".collection-filter");
    let priceMin = document.getElementById("price-min");
    let priceMax = document.getElementById("price-max");
    let priceDisplayMin = document.getElementById("price-display-min");
    let priceDisplayMax = document.getElementById("price-display-max");
    let applyFilterBtn = document.getElementById("apply-price-filter");

    if (!priceMin || !priceMax || !priceDisplayMin || !priceDisplayMax || !applyFilterBtn) {
        console.error("One or more filter elements are missing.");
        return;
    }

    // Function to update the displayed price values
    function updatePriceDisplay() {
        priceDisplayMin.textContent = priceMin.value;
        priceDisplayMax.textContent = priceMax.value;
    }

    // Function to apply the filter when the button is clicked
    function applyFilter() {
        let minPrice = parseFloat(priceMin.value) || 0;
        let maxPrice = parseFloat(priceMax.value) || 99999; // Default max if empty

        let params = {
            "filter.v.price.gte": minPrice,
            "filter.v.price.lte": maxPrice
        };

        let url = new URL(window.location.href);
        Object.keys(params).forEach(key => url.searchParams.set(key, params[key]));

        fetch(url.toString(), { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(response => response.text())
        .then(data => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(data, "text/html");
            let newProducts = doc.querySelector(".product-grid");

            if (newProducts) {
                document.querySelector(".product-grid").innerHTML = newProducts.innerHTML;
            }

            // Update browser URL
            window.history.pushState({}, "", url);
        })
        .catch(error => console.error("Error fetching filtered products:", error));
    }

    // Update displayed prices live as user moves the sliders
    priceMin.addEventListener("input", updatePriceDisplay);
    priceMax.addEventListener("input", updatePriceDisplay);

    // Apply the filter only when clicking the button
    applyFilterBtn.addEventListener("click", applyFilter);
});
